import settings from '@/settings'

let list = (headers, payload) => {
    let url = `${settings.apetrusApi}/solicitacoes/`
    if (payload) {
        const keys = Object.keys(payload)
        for (let i = 0; i < keys.length; i++) {
            url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${keys[i]}=${payload[keys[i]]}`
        }
    }
    return fetch(url, {
      method: 'GET',
      mode: 'cors',
      cache: 'default',
      headers: headers
    })
}

let multipleMethods = (headers, payload) => {
    // Atualizar Solicitação, Pegar Detalhes e Deleta Solicitação
    let url = `${settings.apetrusApi}/solicitacoes/${payload.id}/`
    const data = {
        method: payload.method || 'GET',
        mode: 'cors',
        headers: headers
    }

    if (payload.method === 'GET') {
        data.cache = 'default'
        if (payload) {
          const keys = Object.keys(payload)
          for (let i = 0; i < keys.length; i++) {
            url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${keys[i]}=${payload[keys[i]]}`
          }
        }
      } else data.body = JSON.stringify(payload)

    return fetch(url, data)
}

export default {
    list,
    multipleMethods
}
